/**
 * Publish Form Core Atoms - State management for store publication form
 */

import { atom } from "jotai";

// ============================================================================
// TYPES
// ============================================================================

export interface PublishFormData {
  isFree: boolean;
  price: string;
  title: string;
  detailedDescription: string;
  tags: string[];
  selectedSpecialties: string[];
  selectedPatientTypes: string[];
  selectedDestinations: string[];
  comorbidities: string[];
  imageFile: File | null;
  imagePreview: string;
}

// Valeurs par défaut
const defaultFormData: PublishFormData = {
  isFree: false,
  price: "",
  title: "",
  detailedDescription: "",
  tags: [],
  selectedSpecialties: [],
  selectedPatientTypes: [],
  selectedDestinations: [],
  comorbidities: [],
  imageFile: null,
  imagePreview: "/images/placeholder.svg?height=200&width=300",
};

// ============================================================================
// BASE ATOMS
// ============================================================================

const atomCache = new Map<string, ReturnType<typeof atom<PublishFormData>>>();
const getPublishFormAtom = (groupId: string) => {
  const cached = atomCache.get(groupId);
  if (cached) {
    return cached;
  }

  const created = atom<PublishFormData>(defaultFormData);
  atomCache.set(groupId, created);
  return created;
};

/**
 * Manage form state per groupId by caching a dedicated atom for each identifier.
 */
export const publishFormAtomFamily = (groupId: string) => getPublishFormAtom(groupId);

/**
 * Atom pour le compteur de caractères de la description
 */
export const descriptionCharCountAtom = atom<number>(0);
